module.exports = __webpack_public_path__ + "img/benben tsukumo.86295da3.png";